'use client';

import { Container, useAutoPlayVideoRef } from 'components/index';
import { getAssetUrl } from 'lib/config/assetUrls';
import styles from './VideoHero.module.css';

const VideoHero = ({
  title = 'Your body, decoded daily',
  subtitle = 'The Ring AIR seamlessly correlates changes in your sleep, resting HR, HRV, and movement trends with relevant blood markers.',
}: {
  title?: string;
  subtitle?: string;
}) => {
  // Both rendered + CSS-toggled at 992px (in SSR, no swap); per-video IO ref so the hidden one never loads.
  const mobileVideoRef = useAutoPlayVideoRef();
  const desktopVideoRef = useAutoPlayVideoRef();

  const desktopSrc = getAssetUrl(
    `/web_v2/blood-vision/buy/desktop/Web2K_1.mp4`,
  );
  const mobileSrc = getAssetUrl(
    `/web_v2/blood-vision/buy/desktop/Mobile_2K.mp4`,
  );

  return (
    <section className={styles.videoWrapper}>
      <div className={styles.videoContainer}>
        <video
          className={styles.mobileVideo}
          preload="none"
          loop
          autoPlay
          muted
          playsInline={true}
          webkit-playsinline="true"
          ref={mobileVideoRef}
          aria-label="Blood Vision — correlating Ring AIR data with blood biomarkers"
        >
          <source src={mobileSrc} type="video/mp4" />
        </video>
        <video
          className={styles.desktopVideo}
          preload="none"
          loop
          autoPlay
          muted
          playsInline={true}
          webkit-playsinline="true"
          ref={desktopVideoRef}
          aria-label="Blood Vision — correlating Ring AIR data with blood biomarkers"
        >
          <source src={desktopSrc} type="video/mp4" />
        </video>
      </div>
      <Container>
        <div className={styles.textContainer}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </Container>
    </section>
  );
};

export default VideoHero;
